import * as React from 'react';
import { ExperienceProvider } from '@origin-digital/features';
import { HeaderContent } from './HeaderContent';

export const qualifyingPostcodes = ['4', '5', '9'];

export const isQualifyingPostcode = (postcode: string) => {
  const firstNumber = postcode && postcode.charAt(0);
  return qualifyingPostcodes.includes(firstNumber);
};

export const STATE_NAMES = { 4: 'Queensland', 5: 'South Australia', 9: 'Queensland' };

export const getStateName = (postcode: string) => {
  const firstNumber = postcode && postcode.charAt(0);
  return STATE_NAMES[firstNumber];
};

export interface PersonalisedHeaderProps {
  postcode: string;
  isBusiness?: boolean;
}

export const personalisedHeaderMbox = 'OE-631-mbox';

export const PersonalisedHeader = ({ postcode, isBusiness }: PersonalisedHeaderProps) => {
  const qualifyingPostcode = isQualifyingPostcode(postcode);
  const stateName = getStateName(postcode);
  const customerType = isBusiness ? 'small business' : 'residential';
  return qualifyingPostcode ? (
    <ExperienceProvider mboxes={[personalisedHeaderMbox]}>
      <HeaderContent stateName={stateName} customerType={customerType} />
    </ExperienceProvider>
  ) : null;
};
